<template>
  <div>
    <Overview :overviewData="{}" />
  </div>
</template>

<script>
import Overview from '../Overview'
export default {
  name: 'AsideSegments',
  components: {
    Overview
  }
}
</script>

<style>

</style>
